import styled, { css, keyframes } from "styled-components";

export const FooterD = styled.div`
  pointer-events: ${(p) => (p.clickable ? "auto" : "none")};
`;

const positionUp = keyframes`
  0%{
    animation-timing-function: cubic-bezier(0.17,0.17,0,1);
    transform: translateY(30px);  
       }
  
  100%{
    transform: translateY(0);     
    }
  } 
`;
const opacityUp = keyframes`
  0%{
    animation-timing-function: cubic-bezier(0.5,0,0,1);
    opacity:0; 
     }
  100%{
    opacity:1;  
  } 
`;

const fadeInUpFloorAnim = css`
  ${positionUp} 600ms 1 forwards, ${opacityUp} 217ms 1 forwards
`;
const fadeInDownFloorAnim = keyframes`
  0%{
    animation-timing-function: cubic-bezier(0.5,0,0,1);
    width:150%;
 margin-left: -81px;
    }
  100%{
    width:100%;
 margin-left: 0;

   } 
`;
const fadeInDownFloor = css`
  ${fadeInDownFloorAnim} 600ms 1  , ${opacityUp} 217ms 1 forwards
`;
export const Floor = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
  /* width: 100%; */

  /* transform-origin: right; */
  animation: ${(p) => (p.fadeInUpFloor ? fadeInUpFloorAnim : null)};
  animation: ${(p) => (p.fadeInDownFloor ? fadeInDownFloor : null)};

  div {
    cursor: pointer;
  }
`;

const scaleAnimFooterBtn = keyframes`
  0%{  
    animation-timing-function: cubic-bezier(.33,1,0,1);
    transform: scale(1);
    }
  50%{
    animation-timing-function: cubic-bezier(0,0,0,1);
    transform: scale(.65);

   }
  100%{
    transform: scale(1); 
    } 
`;
const animFooterBtn = css`
  ${scaleAnimFooterBtn} 0.33s 1 forwards
`;
const whiteDivOpa1 = keyframes`
  0%{
    animation-timing-function: cubic-bezier(0,0,.2,1);
    opacity: 0;
     }
  33%{
    animation-timing-function: cubic-bezier(1.5,3.6,.2,1);
     opacity: 0.5;
    }
  100%{
     opacity:0;
  } 
`;

const whiteDivOpa = css`
  ${whiteDivOpa1} 0.33s 1 forwards
`;

const svgAnimOnAnim = keyframes`
    0%{
      stroke-dashoffset: 43;
      transform: rotate(0deg);
    }
    20% {
      transform: rotate(47deg);
    }
    40% {
      transform: rotate(-3deg);
    }
    60% {
      transform: rotate(22deg);
    }
    80% {
      transform: rotate(-5deg);
    }
    100% {
      transform: rotate(0deg);
      stroke-dashoffset: 0;
    }
   
`;

const svgAnimOn = css`
  ${svgAnimOnAnim} 500ms 1 forwards linear
`;

export const Button = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  width: 56px;
  height: 56px;
  border-radius: 28px;
  background-color: ${(p) => (p.isTurboOn ? "#d93d32" : "#ffb000")};
  color: ${(p) => (p.isTurboOn ? "#ffb000" : "#d93d32")};
  transition: background-color 500ms linear;
  font-size: 20px;
  animation: ${(p) => (p.animOn ? animFooterBtn : null)};
  &&.auto {
    svg {
      margin-left: 4px;
    }
  }
  svg {
    path {
      transform-origin: center top;
      stroke-dasharray: 43;
      stroke-dashoffset: 0;
      stroke: ${(p) => (p.isTurboOn ? "#ffb000" : "#d93d32")};

      animation: ${(p) => (p.isTurboOn && !p.autoBtn ? svgAnimOn : null)};
    }
  }

  .white {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50px;
    background: #ffffff;
    opacity: 0;

    animation: ${(p) => (p.animOn ? whiteDivOpa : null)};
  }
`;

const clickBtnBackground = keyframes`
    0% {
      opacity: 0;
    }
    33% {
      opacity: 0.5;
      animation-timing-function: cubic-bezier(0.17, 0.17, 0.2, 1);
    }
    100% {
      opacity: 0;
      animation-timing-function: cubic-bezier(0.17, 0.33, 0.2, 1);
    }
`;

export const btnBackgroundAnim = css`
  ${clickBtnBackground}
`;

export const Bet = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 188px;
  height: 56px;
  border-radius: 28px;
  border: solid 3px #ffb000;
  font-size: 12px;
  div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 107px;
  }

  /* input {
    height: 40px;
    width: 100px;
    color: #ffb000;
    background: transparent;
    outline: none;
    border: none;
  } */
  /* span {
    vertical-align: text-top;
  } */
  span {
    color: #ffb000;
    font-size: 12px;
    max-width: 150px;
    width: 100%;
    position: relative;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: end;
    justify-content: center;
    svg {
      margin-left: 5px;
      height: 11px;

      path {
        fill: #ffb000;
      }
    }
  }
  p {
    line-height: 15px;
  }
  :after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    transform: scale(1);
    background: #ffffff;
    border: solid 3px #ffffff;
    border-radius: 38px;
    opacity: 0;
    animation: ${(props) => (props.setBetA ? btnBackgroundAnim : null)};
    animation-duration: 0.5s;
  }
`;

const playUnpressAnim = keyframes`
  0%{
    transform: scale(.8)
    transition-timing-function: cubic-bezier(0,0,.2,.93);
    /* box-shadow: 0 0 0 0 rgba(50, 7, 91, 0.5); */

   }
  50%{
    transition-timing-function: cubic-bezier(.31,-0.17,.67,1.21);
    transform: scale(1.05);

   }
  100%{
    /* box-shadow: 0 15px 10px 0 rgba(50, 7, 91, 0.5); */

    transform: scale(1);
   } 
`;
const playUnPress = css`
  ${playUnpressAnim} 0.2s 1 forwards
`;
export const Play = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60%;
  max-width: 280px;
  height: 56px;
  border-radius: 28px;
  background: #ffb000;
  font-size: 20px;
  color: #d93d32;
  animation: ${(p) => (p.playUnpress ? playUnPress : null)};
  ${(p) =>
    p.playPress
      ? "transform: scale(0.8);transition-timing-function: cubic-bezier(.29,.16,.29,1.23); transition: transform 0.1s;"
      : "transform: scale(1); transition-timing-function: cubic-bezier(0.1, 0, 0, 1); transition: transform 0.1s;"};
`;

export const Regular = styled.div`
  /* display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; */
`;
